<template>
  <span>
    <a href="#" @click="show = true" class="clickable"><slot></slot></a>
    <b-sidebar
      id="message-functionbox-accounts"
      v-model="show"
      lazy
      right
      no-slide
      shadow
      backdrop
    >
      <div class="px-3 py-2">
        {{ $t("FUNCTIONBOX_USERS") }}

        <hr class="pb-0 mb-0 mt-2 mb-3" />

        <b-table
          class="w-100 mt-2 mb-0 pb-0"
          fixed
          hover
          small
          :fields="fields"
          :items="functionbox_accounts"
        >
          <template v-slot:cell(fetched_date)="data">{{
            FormatDateTime(data.item.fetched_date)
          }}</template>

          <template v-slot:cell(id)="data"><span v-if="getStatus(data.item) == 0"
              ><i class="fal fa-envelope"></i
            ></span>
            <span v-if="getStatus(data.item) == 1"
              ><i class="fal fa-envelope-open"></i
            ></span>
            <span v-if="getStatus(data.item) == 2"
              ><i class="fal fa-file-exclamation"></i
            ></span> </template>

          <template v-slot:cell(email)="data">
             {{data.item.email}}
          </template>

          <template v-slot:cell(state)="data">
            <b-form-checkbox
              v-model="selected"
              name="check-button"
              :value="data.item.id"
            ></b-form-checkbox>
          </template>
        </b-table>
      </div>
    </b-sidebar>
  </span>
</template>
<script>
export default {
  components: {},
  props: ["message_uuid", "functionbox_uuid", "functionbox_accounts"],
  data() {
    return {
      loading: false,
      visible: false,
      show: false,
      fields: [
        {
          key: "id",
          label: "",
          class: "clickable hidden-mobile",
          thClass: "w-icon",
        },
        {
          key: "email",
          label: "Email",
          class: "text-break clickable hidden-mobile",
          thClass: "w-150",
        },
        {
          key: 'fetched_date',
          label: this.$t('VIEWED'),
          class: "text-break clickable hidden-mobile",
          thClass: "w-150",
        },
      ]
    };
  },
  methods: {
    getStatus(item) {
      if (item.claimed == 1) {
        return 2;
      }
      if (item.fetched == 1) {
        return 1;
      }
      return 0;
    },
    showStatus(item) {
      if (item.fetched == 1) {
        return this.$t("VIEWED");
      }
      return this.$t("NOT_VIEWED");
    },
  },
  computed: {
    noCreatorList() {
      return this.functionbox_accounts.filter(function(item) {
        return item.creator == 0;
      });
    },
  },
  mounted() {},
};
</script>
<style></style>
